import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

export const MyPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#e0f2ff',
      100: '#b3dcff',
      200: '#80c4ff',
      300: '#4daeff',
      400: '#269bff',
      500: '#0285ff',
      600: '#0278e6',
      700: '#0266c2',
      800: '#0254a0',
      900: '#01427e',
      950: '#00264d',
    },
  },
  components: {
    card: {
      body: {
        padding: '24px',
      },
      css: () => `
        @media (max-width: 767px) {
          .p-card .p-card-body {
            padding: 12px;
          }
        }
      `,
    },
  },
});
